import { t, Trans } from '@lingui/macro'
import { Button } from '@material-ui/core'
import { Field, Formik } from 'formik'
import React, { useMemo } from 'react'
import { GoPay } from 'shopify-payment-core'
import * as Yup from 'yup'

import { FormTextField } from '../../atoms/FormTextField'
import { i18n } from '../../i18n'

interface IProps {
  fieldIdSuffix: ID
  credentials: Maybe<GoPay.ICredentials>
  onSubmit(credentials: GoPay.ICredentials): Promise<void>
}

const initialCredentials: GoPay.ICredentials = {
  clientId: '',
  clientSecret: '',
  goId: '',
}

export const GoPayCredentialsForm: React.FC<IProps> = ({
  fieldIdSuffix,
  credentials,
  onSubmit,
}) => {
  const requiredMsg = i18n._(t`Musí být vyplněno`)

  const credentialsSchema = useMemo(
    () =>
      Yup.object().shape({
        clientId: Yup.string().required(requiredMsg),
        clientSecret: Yup.string().required(requiredMsg),
        goId: Yup.string().required(requiredMsg),
      }),
    [],
  )

  return (
    <Formik<GoPay.ICredentials>
      onSubmit={onSubmit}
      validationSchema={credentialsSchema}
      initialValues={credentials || initialCredentials}
      isInitialValid={Boolean(credentials)}
      enableReinitialize={true}
    >
      {({ handleSubmit, isValid, isValidating, isSubmitting, values }) => {
        return (
          <>
            <Field
              id={`clientId-${fieldIdSuffix}`}
              name="clientId"
              label={i18n._(t`Client ID`)}
              component={FormTextField}
              fullWidth={true}
            />
            <Field
              id={`clientSecret-${fieldIdSuffix}`}
              name="clientSecret"
              label={i18n._(t`Client Secret`)}
              component={FormTextField}
              fullWidth={true}
            />
            <Field
              id={`goId-${fieldIdSuffix}`}
              name="goId"
              label={i18n._(t`Go ID`)}
              component={FormTextField}
              fullWidth={true}
            />
            <br />
            <br />
            <Button
              // @ts-ignore Badly typed event argument
              onClick={handleSubmit}
              disabled={!isValid || isValidating || isSubmitting}
              variant="contained"
            >
              <Trans>Ověřit a uložit</Trans>
            </Button>
          </>
        )
      }}
    </Formik>
  )
}
